export default function FlightsRoundtripController(
    $scope,
    $state,
    $timeout,
    flightsFactory,
    flightsUtils,
    userService,
    l10nService,
    timeService,
    flightsService,
) {
    'ngInject';

    const vm = this;
    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        getPreviousSearchResults();
        flightsFactory.resetSegmentFilterData();
        watch();
    }

    $scope.findFlights = findFlights;
    $scope.repeatSearch = repeatSearch;
    $scope.isCurrentDay = flightsService.isCurrentDay;
    $scope.showOptions = flightsFactory.showOptions;
    $scope.flightType = 'roundtrip';
    $scope.previousSearches = [];
    $scope.workingHoursRestriction = userService.getUser().WorkingHoursRestriction;

    $scope.updateArrival = function(segmentIndex, isArrival) {
        $scope.params.TicketSearchSegments[segmentIndex]._isArrivalTime = isArrival;
    };
    $scope.updateArrivalOneWay = function(index, value) {
        $scope.params.TicketSearchSegments[index]._isArrivalTime = value === 'true';
    };
    const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.TicketSearchSegments[0]._date);
    const initialReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.TicketSearchSegments[1]._date);

    $scope.optionsDepart = {
        placeholder: l10nService.localize('Date'),
        required: true,
        months: 2,
        start: initialDepartDate,
        after: moment().add({days: -1}),
        before: flightsFactory.getMaxBookDate(),
        dependentPikers: ['optionsReturn'],
    };

    $scope.optionsReturn = {
        placeholder: l10nService.localize('Date'),
        required: true,
        months: 2,
        start: initialReturnDate,
        after: moment(initialDepartDate).add({days: -1}),
        before: flightsFactory.getMaxBookDate(),
    };

    function watch() {
        $scope.$watch('params.TicketSearchSegments[0]._date', departTimeWatcher);
        $scope.$watch('params.TicketSearchSegments[1]._date', returnTimeWatcher);
        $scope.$watch('params.TicketSearchSegments[0]._time', returnTimeWatcher, true);
        $scope.$watch('params.TicketSearchSegments[0]._date',
            flightsUtils.refreshReturnedDate.bind($scope.params.TicketSearchSegments)
        );
    }

    function getPreviousSearchResults() {
        flightsFactory.getAllPreviousSearches(1)
            .then(({data}) => $scope.previousSearches = data);
    }

    function departTimeWatcher() {
        flightsUtils.departureTimeWatcher(
            $scope.params.TicketSearchSegments[0]._date,
            $scope.options.time0,
            $scope.params.TicketSearchSegments[0]._time,
            $scope.options.time
        );
    }

    function navigateToResultsRoute() {
        $state.go('main.flights.results');
    }

    function findFlights() {
        $scope.params.flightType = 'roundtrip';
        flightsFactory.fetchFlights(angular.copy($scope.params), false,
            {
                outbound: $scope.params.TicketSearchSegments[0]._isArrivalTime,
                inbound: $scope.params.TicketSearchSegments[1]._isArrivalTime,
            })
            .then(navigateToResultsRoute);
    }

    function repeatSearch(search) {
        // set open state of 'more options' panel
        $scope.showOptions = flightsUtils.moreOptionsApplied(search);
        flightsFactory.getSearch(search.Id)
            .then((response) => {
                const data = flightsFactory.applyDefaultsForRecentSearch(response.data);
                angular.forEach(data.TicketSearchSegments, (segment, i) => {
                    segment.IsDepartureCity = search.SearchSegments[i].IsDeparturePointCity;
                    segment.IsArrivalCity = search.SearchSegments[i].IsArrivalPointCity;
                });
                if (!angular.isObject(data.TicketSearchSegments[0].DayTimeFilterSource)) {
                    let value = data.TicketSearchSegments[0].DayTimeFilterSource;
                    if (data.TicketSearchSegments[0].DayTimeFilterSource === 0 || 1) {
                        value = value === 1;
                    }
                    $scope.params.TicketSearchSegments[0]._isArrivalTime = value.toString();
                }
                if (!angular.isObject(data.TicketSearchSegments[1].DayTimeFilterSource)) {
                    let value = data.TicketSearchSegments[1].DayTimeFilterSource;
                    if (data.TicketSearchSegments[1].DayTimeFilterSource === 0 || 1) {
                        value = value === 1;
                    }
                    $scope.params.TicketSearchSegments[1]._isArrivalTime = value.toString();
                }
                flightsFactory.params.recreate(search, data, $scope.options, $scope.flightType);
                return flightsFactory.fetchFlights(data, true);
            })
            .then(navigateToResultsRoute);
    }

    function returnTimeWatcher() {
        flightsUtils.returnTimeWatcher(
            $scope.params.TicketSearchSegments[0]._date,
            $scope.params.TicketSearchSegments[1]._date,
            $scope.options.time1,
            $scope.params.TicketSearchSegments[0]._time,
            $scope.params.TicketSearchSegments[1]._time,
            $scope.options.time
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/flightsRoundtripCtrl.js